import { Injectable } from '@angular/core';
import { HttpRequestModel, HttpService } from '../httpservice/http.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PotentialJobCostCodesService {
  HttpRequestModel: HttpRequestModel = new HttpRequestModel();

  constructor(private httpService: HttpService) {}

  //Request to get all jobs cost codes
  getPotentialJobCostCodes(jobId, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_cost_codes/' + jobId;
    this.HttpRequestModel.method = 'GET';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to add/update jobs cost code
  addPotentialJobCostCode(costCodeData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_cost_codes/add';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = costCodeData;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to add/update jobs cost code
  upatePotentialJobCostCode(id, costCodeData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_cost_codes/update/' + id;
    this.HttpRequestModel.method = 'PUT';
    this.HttpRequestModel.body = costCodeData;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to add/update jobs cost code
  addUpatePotentialJobCostCode(costCodeData, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_cost_codes/add_update';
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = costCodeData;

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }

  //Request to delete jobs cost code
  deletePotentialJobCostCode(deleteId, showLoader = false, hideLoader = false): Observable<any> {
    this.HttpRequestModel.reset();
    this.HttpRequestModel.url = 'potential_job_cost_codes/delete/' + deleteId;
    this.HttpRequestModel.method = 'POST';
    this.HttpRequestModel.body = '';

    return this.httpService.init(this.HttpRequestModel, showLoader, hideLoader).pipe(map(response => response));
  }
}
